import { action, makeObservable, observable, runInAction } from 'mobx'

import { adaptRetailerSubscription } from 'shared/adapters/retailer'
import { getRetailerSubscription } from 'shared/api/retailer'

import { SubscriptionPlanStore } from 'retailer/stores'

class RetailerSubscription {
  @observable validFrom
  @observable validTo
  @observable planId
  @observable planName = ''
  @observable autoRenewalCancelled = false
  @observable isActive = true
  @observable productsLeft = 0
  @observable isLimitless = false
  @observable warning = false

  @observable plan

  constructor () {
    makeObservable(this)
  }

  @action.bound
  fetch () {
    return getRetailerSubscription()
      .then(response => {
        const { plan, ...rest } = adaptRetailerSubscription(response.data)
        runInAction(() => {
          Object.assign(this, rest)
          this.plan = new SubscriptionPlanStore(plan)
        })
      })
  }
}

export default RetailerSubscription
